// extracted by mini-css-extract-plugin
export default {"link":"j7pOnl","image":"BI8PVQ","root":"MazNVa"};